/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import Vue from 'vue';
import AppRouterView from './shell/router/AppRouterView.vue';
import router from './shell/router';
import store from './shell/store';
import vuetify from './shell/plugins/vuetify';
import VueI18n from 'vue-i18n';
import i18n from './shell/i18n/i18n';
import PortalVue from 'portal-vue';
import 'overlayscrollbars/css/OverlayScrollbars.min.css';
import 'overlayscrollbars/js/OverlayScrollbars.min.js';
import initPinia from '@/stores';
import {auth} from '@/api/auth';
import observeFirebaseAuth from '@/observers/firebase-auth';

Vue.use(VueI18n);
Vue.use(PortalVue);

Vue.config.productionTip = false;

const pinia = initPinia(Vue);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  pinia,
  render: h => h(AppRouterView)
}).$mount('#app');

observeFirebaseAuth(auth());
